/**
 * Created by Wddzzz on 2019/5/29.
 * 接口地址BASEURL
 */

let LINK = ''

/*========本地=======*/
const DEV_LINK1 = {
  base1:'http://192.168.200.93:8070/guohe/',
  base2:'http://192.168.200.93:8082/guohe/',
  base3:'http://localhost:8080'
}
/*========测试=======*/
const DEV_LINK = {
  base1: 'https://stctest.vanlinks.cn/service/guohe/',
  base2: 'https://stctest.vanlinks.cn/auth/guohe/',
  base3: 'https://wlxytest.haier.net/auth'
}
/*========生产=======*/
const PRO_LINK = {
  base1: 'https://stc.vanlinks.cn/service_guohe/guohe/',//补录接口
  base2: 'https://stc.vanlinks.cn/service_auth/guohe/',//权限接口
  base3: 'https://stc.vanlinks.cn/auth',//页面跳转
}
// const PRO_LINK = {
//   base1: 'http://10.133.5.34:8070/guohe/',//补录接口
//   base2: 'http://10.133.5.34:8082/guohe/',//权限接口
//   base3: 'http://10.133.5.34:8080/auth',//页面跳转
// }
let env = process.env.NODE_ENV
env == 'development' ? (LINK = DEV_LINK) : (LINK = PRO_LINK)

export default {
  LINK
}



// WEBPACK FOOTER //
// ./src/utils/link.js